<div class="container" style="height: 100%; margin: 0px; padding: 10px; width: 100%;overflow-x:hidden;overflow-y:hidden;" id="tranjections">
    <!--Header-->
        <!-- <div class="col-md-12 heading" style="margin-top: 20px;text-align: center;" *ngIf="agencyData[0].Letterhead == ''"> -->
            <!-- <div style="font-size: 20px;"> {{AgencyName}} </div>
            <div style="font-size: 13px;">{{City}}, {{State}}</div>   -->
            <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="agencyData[0].Letterhead == '' && cusHeader != '[]'" style="margin-bottom: 10px;">
                <!-- Header Left side-->
                <div *ngIf="customHeader.side == 1" style="margin: 10px 0px; padding-right: 15px; padding-left: 15px;">
                    <!--Left Side Img-->
                    <div style="padding-left: 0px; display: inline-block; width: 15%; float: right; text-align: right;" *ngIf="customHeader.showLogo && customHeader.cmpLogo">
                        <img src="https://biziverse.com/uploads/CompanyLogo/{{customHeader.cmpLogo}}" style="width: 75%; margin: 0px;" />
                    </div> 
                    <!--Left Side Text-->
                    <div style="padding-right: 0px; text-align: left; display: inline-block; float: left;width: 65%;">
                        <div style="font-size: 25px;" *ngIf="customHeader.cmpName">
                            <span>{{customHeader.cmpName}}</span>
                        </div>
                        <div *ngIf="customHeader.address != ''">
                            <span style="white-space: pre-line; font-size: 12px !important;"> {{customHeader.address}}</span>
                        </div>
                        <div>
                            <div style="display: inline-block; font-size: 12px !important;" *ngIf="customHeader.gstin != ''">
                                <span style="font-weight: bold;">GST : </span> <span> {{customHeader.gstin}} </span>
                            </div> <br />
                            <div style="display: inline-block; font-size: 12px !important;" *ngIf="customHeader.cin != ''">
                                <span style="font-weight: bold;">CIN : </span> <span> {{customHeader.cin}} </span>
                            </div>
                        </div>
                        <div style="display: inline-block; font-size: 12px !important;" *ngIf="customHeader.mobile != ''">
                            <span style="font-weight: bold;">Phone : </span> <span> {{customHeader.mobile}} </span>
                        </div>
                    </div>
                </div>
           
                <!--right Side Img-->
                <div *ngIf="customHeader.side == 2" style="margin: 10px 0px; padding-right: 15px; padding-left: 15px;">
                    <!--right Side Img-->
                    <div style="padding-left: 0px; display: inline-block; width: 15%; float: left; text-align: left;" *ngIf="customHeader.showLogo && customHeader.cmpLogo">
                        <img src="https://biziverse.com/uploads/CompanyLogo/{{customHeader.cmpLogo}}" style="width: 75%; margin: 0px;" />
                    </div>
        
                    <!--right Side Text-->
                    <div style="padding-right: 0px;padding-right: 0px; text-align: right; display: inline-block; float: right; width: 65% !important;">
                        <div style="font-size: 25px;" *ngIf="customHeader.cmpName">
                            <span>{{customHeader.cmpName}}</span>
                        </div>
                        <div *ngIf="customHeader.address != ''">
                            <span style="white-space: pre-line; font-size: 12px !important;"> {{customHeader.address}}</span>
                        </div>
                        <div>
                            <div style="display: inline-block; font-size: 12px !important;" *ngIf="customHeader.gstin != ''">
                                <span style="font-weight: bold;">GST : </span> <span> {{customHeader.gstin}} </span>
                            </div><br />
                            <div style="display: inline-block; font-size: 12px !important;" *ngIf="customHeader.cin != ''">
                                <span style="font-weight: bold;">CIN : </span> <span> {{customHeader.cin}} </span>
                            </div>
                        </div>
                        <div style="display: inline-block; font-size: 12px !important;" *ngIf="customHeader.mobile != ''">
                            <span style="font-weight: bold;">Phone : </span> <span> {{customHeader.mobile}} </span>
                        </div>
                    </div>
                </div>
            </div>
        <!-- </div> -->
        <div style="text-align: center;" *ngIf="agencyData[0].Letterhead != ''">
            <img src="https://biziverse.com/{{agencyData[0].Letterhead}}" style="width: 100%;" alt="Biziverse" />
        </div>
        <div class="col-md-12 heading" style="text-align: center; display: flex; flex-direction: column; align-items: center;">
            <span style="font-weight: bold; font-size: 20px;">
                {{tranjection.XnTypeID == 1 ? 'Goods Receipt Note' : 
                tranjection.XnTypeID == 2 ? 'Receive Unused' : 
                tranjection.XnTypeID == 9 ? 'Store Transfer' : 
                tranjection.XnTypeID == 4 ? 'Delivery Challan' : 
                tranjection.XnTypeID == 5 ? 'Material Issue Slip' : 
                tranjection.XnTypeID == 7 ? 'Return From Job' : 
                tranjection.XnTypeID == 12 ? 'Job Work (Out) - Dispatch': 
                tranjection.XnTypeID == 13 ? 'Job Work (Out) - Receive' : ''}}
            </span>
          </div>
          
        
    <!--Body-->

    <!--4--Delivery Challan-->
    <div class="col-md-12" style="padding-right: 27px;padding-left: 27px;">
        <table *ngIf="tranjection.XnTypeID == 4" class="tbl1" style="width:100%;">
            <tbody><tr>
                <!-- Consignee -->
                <td style="vertical-align: top; width: 50%;">
                    <div class="fontstyle">
                        <b><span>Consignee : </span></b>
                    </div>
                    <div class="fontstyle">
                        <!-- <b><span>Source : </span></b> -->
                        <span>{{excecutiveName}}</span>
                    </div>
                    <div *ngIf="addShow">
                        <div class="fontstyle" >
                            <span> {{add.Name}}{{add.Line1 ? ',' : ''}}{{add.Line1}}{{add.Line2 ? ',' : ''}}{{add.Line2}}</span>
                        </div>
                        <div class="fontstyle">
                            <span>{{add.City}}, {{add.State}}</span>
                        </div>
                        <div *ngIf="add.Pin" class="fontstyle">
                            <span>{{add.Pin}}</span>
                        </div>
                    </div>
                    
                    
                    <div *ngIf="orderNo != 0" class="fontstyle">
                        <span><b>Order No. : </b></span><span>{{orderNo}}</span>
                    </div>
                    <div *ngIf="orderDate" class="fontstyle">
                        <span><b>Order Date : </b></span><span>{{orderDate | date : 'dd-MMM-yy'}}</span>
                    </div>
                   
                    <div class="fontstyle" *ngIf="add.GSTIN">
                        <b><span>GSTIN : </span></b>
                        <span>{{add.GSTIN}}</span>
                    </div>
                  
                </td>
    
                <!-- Challan Detail -->
                <td style="vertical-align: top; width: 50%;text-align: right;">
                    <div class="alignRight fontstyle">
                        <span><b>DC No. : </b></span><span style="font-weight: bold; font-size: 15px;">{{tranjection.RefNo}}</span>
                    </div>
                    <div class="alignRight fontstyle">
                        <span><b>Dispatch Date : </b></span><span>{{tranjection.Date | date: 'dd-MMM-yy'}}</span>
                    </div>
                    <!-- <div class="alignRight fontstyle" *ngIf="tranjection.Ref != 0" class="fontstyle">
                        <b><span>Transaction Ref : </span></b>
                        <span>{{tranjection.Ref}}</span>
                    </div> -->
                    <div class="alignRight fontstyle" *ngIf="tranjection.XnFields.length > 0">
                    <div *ngFor="let f of tranjection.XnFields let i = index" class="fontstyle">
                        <b><span>{{f.key}} : </span></b>
                        <span>{{f.val}}</span>
                    </div>
                    </div>
                   
                </td>
            </tr>
        </tbody></table>
    </div>
    <!--Delivery Challan table-->
    <div class="col-md-12 col-lg-12 col-sm-12" style="vertical-align: top; margin-top: 20px;padding-right: 27px;padding-left: 27px;">
        <table *ngIf="tranjection.XnTypeID == 4" class="grvStyle font"
            style="border-collapse: collapse; width: 100%; margin-bottom: 20px;border:1px solid black;">
            <thead>
                <tr>
                    <td style="font-weight: bold; width: 3%;">No.</td>
                    <td style="font-weight: bold; width: 15%;">Code</td>
                    <td style="font-weight: bold; width: 72%;">Item & Description</td>
                    <td style="font-weight: bold; width: 5%; ">Qty</td>
                    <td style="font-weight: bold; width: 5%; ">Unit</td>
                    <!-- <td style="font-weight: bold; width: 5%;">Rate</td>
                    <td style="font-weight: bold; width: 5%;">Total</td> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items let i = index">
                    <td style="text-align:right;">{{item.SrNo}}</td>
                    <td style="width: 10%; vertical-align: top;">{{item.ItemCode}}</td>
                    <!-- <td style="text-align:left; width: 72%"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span> <br/> {{item.Notes}} </td> -->
                    <td style="text-align:left; width: 72%"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span><br/><span *ngIf="item.Notes" style="word-break: break-word;"> {{item.Notes}} <br/></span> <span *ngIf="item.btchStr != '' && (item.BatchType == 1 || item.BatchType == 2)">Batches : {{item.btchStr}}</span></td>

                    <td style="text-align:right;">{{item.OQ}}</td>
                    <td style="text-align:left;">{{item.Unit}}</td>
                    <!-- <td style="text-align:right;">{{item.Rate | lacFormat : 0}}</td>
                    <td style="text-align:right">{{item.Total | lacFormat : 0}}</td> -->
                </tr>
            </tbody>
            <!-- <tbody>
                <tr>
                    <td colspan="5" style="font-weight: bold; text-align:right; border-top:1px solid black !important">
                        <div>Total</div>
                    </td>
                    <td style="text-align: right;">
                        <div style="text-align: right;">{{total | lacFormat : 0}}</div>
                    </td>
                </tr>
            </tbody> -->
        </table>
    </div>
    
   <!--1--GRN-->
    <div class="col-md-12" style="padding-right: 35px;padding-left: 35px;">
    <table *ngIf="tranjection.XnTypeID == 1" class="tbl1" style="width:100%;">
        <tbody><tr>
            <!-- Supplier -->
            <td style="vertical-align: top; width: 50%;">
                <div class="fontstyle">
                    <b><span>Source : </span></b>
                    <span>{{excecutiveName}}</span>
                </div>
                <!-- <div *ngIf="tranjection.Ref != 0" class="fontstyle">
                    <b><span>Transaction Ref: </span></b>
                    <span>{{tranjection.Ref}}</span>
                </div> -->
                <div *ngIf="tranjection.XnFields.length > 0">
                <div *ngFor="let f of tranjection.XnFields let i = index" class="fontstyle">
                    <b><span>{{f.key}} : </span></b>
                    <span>{{f.val}}</span>
                </div>
                </div>
            </td>

            <!-- Challan Detail -->
            <td style="vertical-align: top; width: 50%;text-align: right;">
                <div class="alignRight fontstyle">
                    <span><b>GRN No. : </b></span><span style="font-weight: bold; font-size: 15px;">{{tranjection.RefNo}}</span>
                </div>
                <div class="alignRight fontstyle">
                    <span><b>Date : </b></span><span>{{tranjection.Date | date: 'dd-MMM-yy'}}</span>
                </div>
                <div class="alignRight fontstyle">
                    <span><b>In Store : </b></span><span>{{storeName}}</span>
                </div>
                <div class="alignRight fontstyle">
                    <span><b>Received by : </b></span><span>{{recieveBy}}</span>
                </div>
            
            </td>
        </tr>
    </tbody></table>
    </div>
    <div class="col-md-12 col-lg-12 col-sm-12" style="vertical-align: top;margin-top: 20px;padding-right: 35px;padding-left: 35px;">
        <table *ngIf="tranjection.XnTypeID == 1" class="grvStyle font"
            style="border-collapse: collapse; width: 100%; margin-bottom: 20px;border:1px solid black;">
            <thead>
                <tr style="vertical-align: top !important">
                    <td style="font-weight: bold; width: 3%;">No.</td>
                    <td style="font-weight: bold; width: 15%;">Code</td>
                    <td style="font-weight: bold; width: 72%;">Item & Description</td>
                    <!-- <td style="font-weight: bold; width: 5%; text-align:center">Batch No. </td> -->
                    <td style="font-weight: bold; width: 5%;">Qty</td>
                    <td style="font-weight: bold; width: 5%;">Unit</td>
                    <!-- <td style="font-weight: bold; width: 10%; text-align:center">Rate &nbsp; (<span>₹</span>)</td>
                    <td style="font-weight: bold; width: 10%; text-align:center">Amount <br> (<span>₹</span>) </td> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items let i = index">
                    <td style="text-align:right;">{{item.SrNo}}</td>
                    <td style="width: 10%; vertical-align: top;">{{item.ItemCode}}</td>
                    <!-- <td style="text-align:left; width: 72%"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span> <br/> {{item.Notes}} </td> -->
                    <td style="text-align:left; width: 72%"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span> <br/> <span *ngIf="item.Notes"> {{item.Notes}}  <br/></span> <span *ngIf="item.btchStr != '' && (item.BatchType == 1 || item.BatchType == 2)">Batches : {{item.btchStr}}</span></td>

                    <!-- <td style="text-align:right;">-</td> -->
                    <td style="text-align:right;">{{item.IQ}}</td>
                    <td style="text-align:left">{{item.Unit}}</td>
                    <!-- <td style="text-align:right;">{{item.Rate | lacFormat : 0}}</td>
                    <td style="text-align:right">{{item.Total | lacFormat : 0}}</td> -->
                </tr>
            </tbody>
        </table>
    </div>
    
    <!--5--Issue-->
    <div class="col-md-12" style="padding-right: 35px;padding-left: 35px;">
        <table *ngIf="tranjection.XnTypeID == 5" class="tbl1" style="width:100%;">
            <tbody><tr>
                
                <td style="vertical-align: top; width: 50%;">
                    <div class="fontstyle">
                        <b><span>Store : </span></b>
                        <span>{{storeName}}</span>
                    </div>
                    <div class="fontstyle">
                        <b><span>Issued by : </span></b>
                        <span>{{recieveBy}}</span>
                    </div>
                    <div class="fontstyle">
                        <b><span>Issued to : </span></b>
                        <span>{{toUserName}}</span>
                    </div>
                    <!-- <div *ngIf="tranjection.Ref != 0" class="fontstyle">
                        <b><span>Transaction Ref: </span></b>
                        <span>{{tranjection.Ref}}</span>
                    </div> -->
                    <div *ngIf="tranjection.XnFields.length > 0">
                    <div *ngFor="let f of tranjection.XnFields let i = index" class="fontstyle">
                        <b><span>{{f.key}} : </span></b>
                        <span>{{f.val}}</span>
                    </div>
                    </div>
                </td>
    
                <!-- Challan Detail -->
                <td style="vertical-align: top; width: 50%;text-align: right;">
                    <div class="alignRight fontstyle">
                        <span><b>Ref No. : </b></span><span style="font-weight: bold; font-size: 15px;">{{tranjection.RefNo}}</span>
                    </div>
                    <div class="alignRight fontstyle">
                        <span><b>Issued Date : </b></span><span>{{tranjection.Date | date: 'dd-MMM-yy'}}</span>
                    </div>
                    <!-- <div class="alignRight fontstyle">
                        <span><b>Dept. : </b></span><span>{{storeName}}</span>
                    </div> -->
                    <div class="alignRight fontstyle" *ngIf="tranjection.PrdJobNo">
                        <span><b>Against Job No. : </b></span><span>{{ tranjection.PrdJobNo }}</span>
                    </div>            
                </td>
            </tr>
        </tbody></table>
    </div>
    <div class="col-md-12 col-lg-12 col-sm-12" style="vertical-align: top;margin-top: 20px;padding-right: 35px;padding-left: 35px;">
        <table *ngIf="tranjection.XnTypeID == 5" class="grvStyle font"
            style="border-collapse: collapse; width: 100%; margin-bottom: 20px;border:1px solid black;">
            <thead>
                <tr>
                    <td style="font-weight: bold; width: 3%;">No.</td>
                    <td style="font-weight: bold; width: 15%;">Code</td>
                    <td style="font-weight: bold; width: 72%;">Item & Description</td>
                    <!-- <td style="font-weight: bold; width: 5%; text-align:center">Batch No. </td> -->
                    <td style="font-weight: bold; width: 5%;">Qty</td>
                    <td style="font-weight: bold; width: 5%;">Unit</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items let i = index">
                    <td style="text-align:right;">{{item.SrNo}}</td>
                    <td style="width: 10%; vertical-align: top;">{{item.ItemCode}}</td>
                    <!-- <td style="text-align:left; width: 72%;"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span> <br/> {{item.Notes}} </td> -->
                    <td style="text-align:left; width: 72%;"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span> <br/> <span *ngIf="item.Notes"> {{item.Notes}} <br/></span> <span *ngIf="item.btchStr != '' && (item.BatchType == 1 || item.BatchType == 2)">Batches : {{item.btchStr}}</span> </td>

                    <!-- <td style="text-align:right;">-</td> -->
                    <td style="text-align:right;">{{item.OQ}}</td>
                    <td style="text-align:left">{{item.Unit}}</td>
                </tr>
            </tbody>
        </table>
    </div>
   
    <!--9--Store Transfer-->
    <div class="col-md-12" style="padding-right: 35px;padding-left: 35px;">
        <table *ngIf="tranjection.XnTypeID == 9 || tranjection.XnTypeID == 12 || tranjection.XnTypeID == 13" class="tbl1" style="width:100%;">
            <tbody><tr>
                
                <td style="vertical-align: top; width: 50%;">
                    <div *ngIf="tranjection.XnTypeID == 9" class="fontstyle">
                        <b><span>From Store : </span></b>
                        <span>{{outStoreName}}</span>
                    </div>
                    <!-- <div *ngIf="tranjection.Ref != 0" class="fontstyle">
                        <b><span>Transaction Ref: </span></b>
                        <span>{{tranjection.Ref}}</span>
                    </div> -->
                    <div *ngIf="tranjection.XnFields.length > 0">
                    <div *ngFor="let f of tranjection.XnFields let i = index" class="fontstyle">
                        <b><span>{{f.key}} : </span></b>
                        <span>{{f.val}}</span>
                    </div>
                    </div>
                    <div *ngIf="tranjection.XnTypeID == 12">
                        <div class="fontstyle">
                            <span><b>To : </b></span>
                        </div>
                        <div class="fontstyle {{excecutiveName != '' ? '' : 'displayNone'}}">
                            <span>{{excecutiveName}}</span>
                        </div>
                        <div class="fontstyle {{(add.City != '' || add.State != '') ? '' : 'displayNone'}}">
                            <!-- <span><b>Address : </b></span> -->
                            <span *ngIf="add.City != ''">{{add.City}}</span>
                            <span *ngIf="add.City != '' && add.State != ''">, </span>
                            <span *ngIf="add.State != ''">{{add.State}}</span>
                        </div>
                    </div>
                    <div *ngIf="tranjection.XnTypeID == 13 && compRelName != ''">
                        <div class="fontstyle">
                            <span><b>From : </b></span><span>{{compRelName}}</span>
                        </div>
                    </div>
                </td>
    
                <!--Store Transfer Details-->
                <td style="vertical-align: top; width: 50%;text-align: right;">
                    <div class="alignRight fontstyle">
                        <span><b>Ref No. : </b></span><span style="font-weight: bold; font-size: 15px;">{{tranjection.RefNo}}</span>
                    </div>
                    <div *ngIf="tranjection.XnTypeID == 9" class="alignRight fontstyle">
                        <span><b>To Store : </b></span><span>{{storeName}}  </span>
                    </div> 
                    <div class="alignRight fontstyle">
                        <b><span *ngIf="tranjection.XnTypeID == 9">Transfer </span> Date : </b><span>{{tranjection.Date | date: 'dd-MMM-yy'}}</span>
                    </div> 
                </td>
            </tr>
        </tbody></table>
    </div>
    <!--store Tran Table Body-->   
    <div class="col-md-12 col-lg-12 col-sm-12" style="vertical-align: top;margin-top: 20px;padding-right: 35px;padding-left: 35px;">
        <table *ngIf="tranjection.XnTypeID == 9 || tranjection.XnTypeID == 12 || tranjection.XnTypeID == 13" class="grvStyle font"
            style="border-collapse: collapse; width: 100%; margin-bottom: 20px;border:1px solid black;">
            <thead>
                <tr>
                    <td style="font-weight: bold; width: 3%; text-align: right;">No.</td>
                    <td style="font-weight: bold; width: 15%;">Code</td>
                    <td style="font-weight: bold; width: 72%;">Item & Description</td>
                    <!-- <td style="font-weight: bold; width: 5%; text-align:center">Batch No. </td> -->
                    <td style="font-weight: bold; width: 5%; text-align: right;">Qty</td>
                    <td style="font-weight: bold; width: 5%;">Unit</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items let i = index" >
                    <td style="text-align:right;">{{i + 1}}</td>
                    <td style="width: 10%; vertical-align: top;">{{item.ItemCode}}</td>
                    <td style="text-align:left; width: 72%"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span> <br/> {{item.Notes}}</td>
                    <!-- <td style="text-align:right;">-</td> -->
                    <td style="text-align:right;">{{item.IQ}}</td>
                    <td style="text-align:left">{{item.Unit}}</td>
                </tr>
            </tbody>
        </table>
    </div>
   
    <!--7--Return From Job-->
    <div class="col-md-12" style="padding-right: 35px;padding-left: 35px;">
        <table *ngIf="tranjection.XnTypeID == 7" class="tbl1" style="width:100%;">
            <tbody><tr>
                
                <td style="vertical-align: top; width: 50%;">
                    <div class="fontstyle">
                            <b><span> Store : </span></b>
                            <span>{{storeName}}</span>
                    </div>
                    <div class="fontstyle">
                        <b><span> WIP No : </span></b>
                        <span>{{tranjection.PrdJobNo}}</span>
                    </div>
                    <!-- <div class="fontstyle">
                        <span>{{supplire}}</span>
                    </div> -->
                    <!-- <div *ngIf="tranjection.Ref !=0" class="fontstyle">
                        <b><span>Transaction Ref : </span></b>
                        <span>{{tranjection.Ref}}</span>
                    </div> -->
                    <div *ngIf="tranjection.XnFields.length > 0">
                    <div *ngFor="let f of tranjection.XnFields let i = index" class="fontstyle">
                        <b><span>{{f.key}} : </span></b>
                        <span>{{f.val}}</span>
                    </div>
                    </div>
                </td>

                <!--Return From Job-->
                <td style="vertical-align: top; width: 50%;text-align: right;">
                    <div class="alignRight fontstyle">
                        <span><b>Ref No. : </b></span><span style="font-weight: bold; font-size: 15px;">{{tranjection.RefNo}}</span>
                    </div>
                    <div class="alignRight fontstyle">
                        <span><b>Date : </b></span><span>{{tranjection.Date | date: 'dd-MMM-yy'}}</span>
                    </div> 
                    <!-- <div class="alignRight fontstyle">
                        <span><b>To Store: </b></span><span>{{outStoreName}}  </span>
                    </div>   -->
                    <div class="alignRight fontstyle">
                        <span><b>Received by : </b></span><span>{{recieveBy}}  </span>
                    </div>         
                </td>
            </tr>
        </tbody></table>
    </div>
    <!--Return From Job-->   
    <div class="col-md-12 col-lg-12 col-sm-12" style="vertical-align: top;margin-top: 20px;padding-right: 35px;padding-left: 35px;">
        <table *ngIf="tranjection.XnTypeID == 7" class="grvStyle font"
            style="border-collapse: collapse; width: 100%; margin-bottom: 20px;border:1px solid black;">
            <thead>
                <tr>
                    <td style="font-weight: bold; width: 3%;">No.</td>
                    <td style="font-weight: bold; width: 15%;">Code</td>
                    <td style="font-weight: bold; width: 72%;">Item & Description</td>
                    <!-- <td style="font-weight: bold; width: 5%; text-align:center">Batch No. </td> -->
                    <td style="font-weight: bold; width: 5%;">Qty</td>
                    <td style="font-weight: bold; width: 5%;">Unit</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items let i = index">
                    <td style="text-align:right;">{{item.SrNo}}</td>
                    <td style="width: 10%; vertical-align: top;">{{item.ItemCode}}</td>
                    <td style="text-align:left; width: 72%"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span> <br/> <span *ngIf="item.Notes"> {{item.Notes}}  <br/></span> <span *ngIf="item.btchStr != '' && (item.BatchType == 1 || item.BatchType == 2)">Batches : {{item.btchStr}}</span></td>

                    <!-- <td style="text-align:left; width: 72%"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span> <br/> {{item.Notes}}</td> -->
                    <!-- <td style="text-align:right;">-</td> -->
                    <td style="text-align:right;">{{item.IQ}}</td>
                    <td style="text-align:left">{{item.Unit}}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <!--2--Received From User / return from unused-->
    <div class="col-md-12" style="padding-right: 35px;padding-left: 35px;">
            <table *ngIf="tranjection.XnTypeID == 2" class="tbl1" style="width:100%;">
                <tbody><tr>
                    
                    <td style="vertical-align: top; width: 50%;">
                        <div class="fontstyle">
                            <b><span>Store : </span></b>
                            <span>{{storeName}}</span>
                        </div>
                        <div class="alignRight fontstyle">
                            <span><b>Received from : </b></span>
                            <span>{{toUserName}}  </span>
                        </div> 
                        <!-- <div *ngIf="tranjection.Ref !=0" class="fontstyle">
                            <b><span>Transaction Ref : </span></b>
                            <span>{{tranjection.Ref}}</span>
                        </div> -->
                        <div *ngIf="tranjection.XnFields.length > 0">
                        <div *ngFor="let f of tranjection.XnFields let i = index" class="fontstyle">
                            <b><span>{{f.key}} : </span></b>
                            <span>{{f.val}}</span>
                        </div>
                        </div>
                    </td>
    
                    <!--Received From User Details-->
    
                    <td style="vertical-align: top; width: 50%;text-align: right;">
                        <div class="alignRight fontstyle">
                            <span><b>Ref No. : </b></span><span style="font-weight: bold; font-size: 15px;">{{tranjection.RefNo}}</span>
                        </div>
                        <div class="alignRight fontstyle">
                            <span><b>Date : </b></span><span>{{tranjection.Date | date: 'dd-MMM-yy'}}</span>
                        </div> 
                        <div class="alignRight fontstyle">
                            <span><b>Received by : </b></span><span>{{recieveBy}}  </span>
                        </div>      
                        <div class="fontstyle" *ngIf="tranjection.PrdJobNo">
                            <b><span> WIP No : </span></b>
                            <span>{{tranjection.PrdJobNo}}</span>
                        </div>   
                    </td>
                </tr>
            </tbody></table>
    </div>

    <!--Received From User Table Body-->   
    <div class="col-md-12 col-lg-12 col-sm-12" style="vertical-align: top;margin-top: 20px;padding-right: 35px;padding-left: 35px;">
            <table *ngIf="tranjection.XnTypeID == 2" class="grvStyle font"
                style="border-collapse: collapse; width: 100%; margin-bottom: 20px;border:1px solid black;">
                <thead>
                    <tr>
                        <td style="font-weight: bold; width: 3%;">No.</td>
                        <td style="font-weight: bold; width: 15%;">Code</td>
                        <td style="font-weight: bold; width: 72%;">Item & Description</td>
                        <!-- <td style="font-weight: bold; width: 5%; text-align:center">Batch No. </td> -->
                        <td style="font-weight: bold; width: 5%;">Qty</td>
                        <td style="font-weight: bold; width: 5%; ">Unit</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items let i = index">
                        <td style="text-align:right;">{{item.SrNo}}</td>
                        <td style="width: 10%; vertical-align: top;">{{item.ItemCode}}</td>
                        <!-- <td style="text-align:left; width: 72%"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span> <br/> {{item.Notes}}</td> -->
                        <td style="text-align:left; width: 72%"><span style="font-weight: {{showBlod ? 'bold' : 'normal'}};">{{item.ItemName}}</span> <br/> <span *ngIf="item.Notes"> {{item.Notes}}  <br/></span> <span *ngIf="item.btchStr != '' && (item.BatchType == 1 || item.BatchType == 2)">Batches : {{item.btchStr}}</span></td>

                        <!-- <td style="text-align:right;">-</td> -->
                        <td style="text-align:right;">{{item.IQ}}</td>
                        <td style="text-align:left">{{item.Unit}}</td>
                    </tr>
                </tbody>
            </table>
    </div>
       
    <div class="col-md-12 col-12 col-xs-12 font" style="display: inline-block; padding-left: 35px; padding-right: 35px; position: relative; top: -15px;" 
        *ngIf="tranjection.XnNotes != ''">
        <span style="font-weight: bold;">Note :</span>
        <span>{{tranjection.XnNotes}}</span>
    </div>

    <div class="col-md-12 col-12 col-xs-12 font" style="display: inline-block;text-align: right;padding-right: 35px;padding-left: 35px;">
        <div style="display: inline-block;width: 50%;text-align: right;">
            For {{AgencyName}},
        </div>
    </div>
    <div style="margin-top: 30px;padding-right: 35px;padding-left: 35px;font-size: 12px;display: inline-block;width: 100%;text-align: right;">Authorized Signature</div>

</div>